import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import PageMeta from "@/components/PageMeta";
import { Plus } from "lucide-react";
import { Link } from "react-router-dom";

// Lazy load below-the-fold sections
const TrendingSkins = lazy(() => import("@/components/TrendingSkins"));
const TrendingCreators = lazy(() => import("@/components/TrendingCreators"));
const Footer = lazy(() => import("@/components/Footer"));

const SectionFallback = ({ minHeight = "min-h-[600px]" }: { minHeight?: string }) => (
  <div className={`flex items-center justify-center ${minHeight}`}>
    <div className="w-6 h-6 border-3 border-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <PageMeta
        title="Free Minecraft Skins & Skin Editor"
        description="Browse and download free Minecraft skins – Anime, Boy, Girl, Cool, HD, Trending & New skins. Create custom skins with our free Skin Editor."
        keywords="Minecraft Skin Download, Free Minecraft Skins, Custom Minecraft Skin, Minecraft Java Skins, Minecraft Bedrock Skins, Anime Minecraft Skins, Skin Editor"
        canonical="/"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Minecraft Skin World",
            "url": "https://minecraftskinworld.com",
            "logo": "https://benvxgwfklfcjqaamkjp.supabase.co/storage/v1/object/public/email-assets/logo.png",
            "sameAs": ["https://twitter.com/MCskinworld"]
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Minecraft Skin World",
            "url": "https://minecraftskinworld.com",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://minecraftskinworld.com/explore?q={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          }
        ]}
      />
      <Navbar />
      <HeroSection />
      <main id="main-content">
        <Suspense fallback={<SectionFallback minHeight="min-h-[1800px] md:min-h-[1200px]" />}>
          <TrendingSkins />
        </Suspense>
        <Suspense fallback={<SectionFallback minHeight="min-h-[500px] md:min-h-[400px]" />}>
          <TrendingCreators />
        </Suspense>
        <Suspense fallback={<SectionFallback minHeight="min-h-[350px] md:min-h-[250px]" />}>
          <Footer />
        </Suspense>
      </main>

      {/* Floating upload button */}
      <Link to="/upload" className="floating-btn transition-all duration-300" aria-label="Upload skin">
        <Plus className="w-6 h-6 text-primary-foreground" />
      </Link>
    </div>
  );
};

export default Index;
